module.exports = {
  BulletData: () => {
    return {
      "arquitectonica" : 
        [
          {
            "id" : "bullet-arquitectonica-0",
            "title": "",
            "text": "Producida con acero galvanizado, acero METALUM (Aleacion de aluminio 55%, Zinc 43,5% y Silicio 1,5) y acero pintado en una gran gama de colores (Pintura libre de plomo)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: 0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-arquitectonica-1",
            "title": "",
            "text": "El acero utilizado en la fabricación de las Cubiertas Acesco  es estructural Grado 40 y Grado 80; además, cumple con la sección F.4.1.2 de la NSR-10",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-arquitectonica-2",
            "title": "",
            "text": "Ahorros de hasta un 50% en tiempos de instalación y costos de mantenimiento, frente a sistemas tradicionales",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-arquitectonica-3",
            "title": "",
            "text": "Los colores de las Cubiertas Acesco cuentan con SRI (Indice de reflectancia solar)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-arquitectonica-4",
            "title": "Más liviana",
            "text": "Frente a otras cubiertas fabricadas en otros materiales, no aporta un peso significativo a su estructura.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-arquitectonica-5",
            "title": "Producto Amigable con el medio ambiente",
            "text": "Son fabricadas en acero, material reciclable, y cuentan con Declaración Ambiental de Producto (DAP), garantizándole  una solución que cumple con los requisitos exigidos en las normas de certificación de edificaciones sostenibles como LEED, EDGE, HQE, BREEAM y CASA.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-arquitectonica-6",
            "title": "",
            "text": "Doble capa protectora para mayor resistencia a la corrosión",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-arquitectonica-7",
            "title": "Garantía Acesco.",
            "text": "*Aplican términos y condiciones",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: -0.1,
              z: 0.0
            }
          },
        ]
      ,
      "master1000" : 
        [
          {
            "id" : "bullet-master1000-0",
            "title": "",
            "text": "Producida con acero galvanizado, acero METALUM (Aleacion de aluminio 55%, Zinc 43,5% y Silicio 1,5) y acero pintado en una gran gama de colores (Pintura libre de plomo)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: 0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-master1000-1",
            "title": "",
            "text": "El acero utilizado en la fabricación de las Cubiertas Acesco  es estructural Grado 40 y Grado 80; además, cumple con la sección F.4.1.2 de la NSR-11",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-master1000-2",
            "title": "",
            "text": "Ahorros de hasta un 50% en tiempos de instalación y costos de mantenimiento, frente a sistemas tradicionales",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-master1000-3",
            "title": "",
            "text": "Los colores de las Cubiertas Acesco cuentan con SRI (Indice de reflectancia solar)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-master1000-4",
            "title": "Más liviana",
            "text": "Frente a otras cubiertas fabricadas en otros materiales, no aporta un peso significativo a su estructura.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-master1000-5",
            "title": "Producto Amigable con el medio ambiente",
            "text": "Son fabricadas en acero, material reciclable, y cuentan con Declaración Ambiental de Producto (DAP), garantizándole  una solución que cumple con los requisitos exigidos en las normas de certificación de edificaciones sostenibles como LEED, EDGE, HQE, BREEAM y CASA.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-master1000-6",
            "title": "",
            "text": "Doble capa protectora para mayor resistencia a la corrosión",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-master1000-7",
            "title": "Garantía Acesco.",
            "text": "*Aplican términos y condiciones",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: -0.1,
              z: 0.0
            }
          }
        ]
      ,
      "sintraslapo" : 
        [
          {
            "id" : "bullet-sintraslapo-0",
            "title": "",
            "text": "Producida con acero galvanizado, acero METALUM (Aleacion de aluminio 55%, Zinc 43,5% y Silicio 1,5) y acero pintado en una gran gama de colores (Libre de plomo)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: 0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-sintraslapo-1",
            "title": "",
            "text": "El acero utilizado en la fabricación de cubiertas es acero estructural grado 40/80 y cumple con la sección F.4.1.2 de la NSR-12",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-2",
            "title": "",
            "text": "Ahorros de hasta un 50% en tiempos de instalación y costos de mantenimiento, frente a sistemas tradicionales",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-3",
            "title": "",
            "text": "Los colores de las Cubiertas Acesco cuentan con SRI (Indice de reflectancia solar)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-4",
            "title": "Más liviana",
            "text": "Frente a otras cubiertas fabricadas en otros materiales, no aporta un peso significativo a su estructura.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: 0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-5",
            "title": "Producto Amigable con el medio ambiente",
            "text": "Son fabricadas en acero, material reciclable, y cuentan con Declaración Ambiental de Producto (DAP), garantizándole  una solución que cumple con los requisitos exigidos en las normas de certificación de edificaciones sostenibles como LEED, EDGE, HQE, BREEAM y CASA.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.15,
              z: 0.0
            }
          },
          {
            "id" : "bullet-sintraslapo-6",
            "title": "",
            "text": "Doble capa protectora para mayor resistencia a la corrosión",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: -0.15,
              z: 0.0
            }
          },
          {
            "id" : "bullet-sintraslapo-7",
            "title": "Tiene hermeticidad",
            "text": "Al no tener traslapos y gracias a su forma de instalar, evitará tener problemas de filtrado de aguas",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.15,
              z: -0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-8",
            "title": "",
            "text": "Para facilitar su instalación y manejo, se fabrica directamente en el sitio de obra y el largo depende de la longitud a cubrir. ",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.15,
              z: 0.5
            }
          },
          {
            "id" : "bullet-sintraslapo-9",
            "title": "Garantía Acesco",
            "text": "*Aplican términos y condiciones",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: -0.15,
              z: 0.0
            }
          },
        ]
      ,
      "canaleta" : 
        [
          {
            "id" : "bullet-canaleta-0",
            "title": "",
            "text": "Producida con acero galvanizado, acero METALUM (Aleacion de aluminio 55%, Zinc 43,5% y Silicio 1,5) y acero pintado en una gran gama de colores (Libre de plomo)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: 0.15,
              z: 0.0
            }
          },
          {
            "id" : "bullet-canaleta-1",
            "title": "",
            "text": "El acero utilizado en la fabricación de cubiertas es acero estructural grado 40/80 y cumple con la sección F.4.1.2 de la NSR-13",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: -0.63
            }
          },
          {
            "id" : "bullet-canaleta-2",
            "title": "",
            "text": "Ahorros de hasta un 50% en tiempos de instalación y costos de mantenimiento, frente a sistemas tradicionales",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.1,
              z: 0.63
            }
          },
          {
            "id" : "bullet-canaleta-3",
            "title": "",
            "text": "Los colores de las Cubiertas Acesco cuentan con SRI (Indice de reflectancia solar)",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: -0.63
            }
          },
          {
            "id" : "bullet-canaleta-4",
            "title": "Más liviana",
            "text": "Frente a otras cubiertas fabricadas en otros materiales, no aporta un peso significativo a su estructura.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.1,
              z: 0.63
            }
          },
          {
            "id" : "bullet-canaleta-5",
            "title": "Producto Amigable con el medio ambiente",
            "text": "Son fabricadas en acero, material reciclable, y cuentan con Declaración Ambiental de Producto (DAP), garantizándole  una solución que cumple con los requisitos exigidos en las normas de certificación de edificaciones sostenibles como LEED, EDGE, HQE, BREEAM y CASA.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-canaleta-5",
            "title": "",
            "text": "Mayor resistencia estructural y distancia entre apoyos. Para cambios de cubiertas antiguas donde hay gran separación de correas, esta cubierta se ajusta a esas necesidades.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: -0.1,
              z: 0.0
            }
          },
          {
            "id" : "bullet-canaleta-6",
            "title": "",
            "text": "11 cms de cresta que permiten mejor evacuación del agua y ayudan a tener un mayor flujo para el autolavado de la cubierta. / Por su geometría, cuenta con gran capacidad de descarga hidráulic ante eventos de lluvias fiuertes.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.1,
              z: -0.5
            }
          },
          {
            "id" : "bullet-canaleta-7",
            "title": "Garantía Acesco",
            "text": "*Aplican términos y condiciones",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.1,
              z: 0.5
            }
          },
        ]
      ,
      "metaldeck" : 
        [
          {
            "id" : "bullet-metaldeck-0",
            "title": "",
            "text": "Ahorros de hasta un 50% en tiempos de instalación, y un 25% en equipos de construcción, frente a sistemas tradicionales",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: 0.2,
              z: 0.0
            }
          },
          {
            "id" : "bullet-metaldeck-1",
            "title": "Producto Amigable con el medio ambiente",
            "text": "Fabricado en acero, material reciclable, y cuentan con Declaración Ambiental de Producto (DAP), garantizándole  una solución que cumple con los requisitos exigidos en las normas de certificación de edificaciones sostenibles como LEED, EDGE, HQE, BREEAM y CASA.",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.2,
              z: -0.5
            }
          },
          {
            "id" : "bullet-metaldeck-2",
            "title": "Metaldeck Grado 50",
            "text": "30% más resistencia estructural",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: 0.2,
              z: 0.5
            }
          },
          {
            "id" : "bullet-metaldeck-3",
            "title": "",
            "text": "Se impone ante los sistemas tradicionales por aspectos como su rapidez en obra, gran resistencia, limpieza, bajo peso y economía. ",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.2,
              z: -0.5
            }
          },
          {
            "id" : "bullet-metaldeck-4",
            "title": "",
            "text": "Las láminas de METALDECK se fabrican con acero  galvanizado calidad estructural Grado 40 y Grado 50",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 1.3,
              y: 0.2,
              z: 0.5
            }
          },
          {
            "id" : "bullet-metaldeck-5",
            "title": "",
            "text": "Menor peso de la losa por su geometría",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.0,
              z: 0.0
            }
          },
          {
            "id" : "bullet-metaldeck-6",
            "title": "",
            "text": "Cumple con las especificaciones del Reglamento NSR-10, ASTM A653/A653M y el documento Composite SteelFloor Deck",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: -1.3,
              y: -0.0,
              z: 0.0
            }
          },
          {
            "id" : "bullet-metaldeck-7",
            "title": "",
            "text": "El recubrimiento de nuestro galvanizado le garantiza durabilidad en el tiempo",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.0,
              z: -0.5
            }
          },
          {
            "id" : "bullet-metaldeck-8",
            "title": "",
            "text": "Su geometría asegura  un excelente comportamiento en la etapa constructiva y aporta menor peso de la losa",
            "image": require("../assets/backgrounds/Arquitectonica.webp"),
            "position": {
              x: 0.0,
              y: -0.0,
              z: 0.5
            }
          }
        ]
      ,
    }
  }
}